module.exports = __webpack_public_path__ + "img/content7.7ed9d67b.png";